<template>
  <div class="fixed-sidebar"
       :class="{_open: open}">
    <div class="fixed-sidebar__main">
      <SideNotifications v-if="open"
                         v-click-out="closeSidebar"
                         class="fixed-sidebar__col"/>
    </div>
  </div>
</template>

<script>
  import {mapState, mapMutations} from 'vuex'
  import SideNotifications from '../components/SideNotifications'

  export default {
    name: "TheFixedSidebar",
    components: {
      SideNotifications
    },
    data() {
      return {

      }
    },
    computed: {
      ...mapState('user/userNotifications', [
        'open',
      ]),
    },
    methods: {
      ...mapMutations('user/userNotifications', [
        'closeNotifications',
      ]),
      closeSidebar() {
        this.closeNotifications()
      }
    }
  }
</script>

